export class UserEventsState {
	userEvents!: any[];
}

export const userEventsInitialState: UserEventsState = {
	userEvents: []
};